function validateStep(step) {
  if (step === 1) {
    var make = document.getElementById('make').value;
    if (make) {
      document.getElementById('model').disabled = false;
      document.getElementById('make-group').classList.remove('highlight');
      document.getElementById('model-group').classList.add('highlight');
    } else {
      document.getElementById('model').disabled = true;
      document.getElementById('year').disabled = true;
      document.getElementById('searchButton').disabled = true;
      document.getElementById('model-group').classList.remove('highlight');
      document.getElementById('year-group').classList.remove('highlight');
      document.getElementById('make-group').classList.add('highlight');
    }
  }
  
  if (step === 2) {
    var model = document.getElementById('model').value;
    if (model) {
      document.getElementById('year').disabled = false;
      document.getElementById('model-group').classList.remove('highlight');
      document.getElementById('year-group').classList.add('highlight');
    } else {
      document.getElementById('year').disabled = true;
      document.getElementById('searchButton').disabled = true;
      document.getElementById('year-group').classList.remove('highlight');
      document.getElementById('model-group').classList.add('highlight');
    }
  }
  
  if (step === 3) {
    var year = document.getElementById('year').value;
    if (year) {
      document.getElementById('searchButton').disabled = false;
      document.getElementById('year-group').classList.remove('highlight');
    } else {
      document.getElementById('searchButton').disabled = true;
      document.getElementById('year-group').classList.add('highlight');
    }
  }
}

function searchBrakePads() {
  var make = document.getElementById('make').value.toLowerCase();
  var model = document.getElementById('model').value.toLowerCase();
  var year = document.getElementById('year').value.toLowerCase();

  if (!make || !model || !year) {
    alert('Please select make, model, and year.');
    return;
  }

  var query = `tag:make_${make} tag:model_${model} tag:year_${year}`;
  
  fetch(`/search/suggest.json?q=${query}&resources[type]=product`)
    .then(response => response.json())
    .then(data => {
      var results = data.resources.results.products;
      var searchResultsDiv = document.getElementById('searchResults');
      searchResultsDiv.innerHTML = '';

      if (results.length > 0) {
        results.forEach(product => {
          var productHtml = `
            <div class="product">
              <a href="${product.url}">
                <img src="${product.featured_image.url}" alt="${product.title}">
                <h3>${product.title}</h3>
              </a>
            </div>
          `;
          searchResultsDiv.innerHTML += productHtml;
        });
      } else {
        searchResultsDiv.innerHTML = '<p>No matching brake pads found.</p>';
      }
    })
    .catch(error => {
      console.error('Error fetching search results:', error);
      var searchResultsDiv = document.getElementById('searchResults');
      searchResultsDiv.innerHTML = '<p>Error fetching search results.</p>';
    });
}

function resetSearchForm() {
  document.getElementById('searchForm').reset();
  document.getElementById('model').disabled = true;
  document.getElementById('year').disabled = true;
  document.getElementById('searchButton').disabled = true;
  document.getElementById('make-group').classList.add('highlight');
  document.getElementById('model-group').classList.remove('highlight');
  document.getElementById('year-group').classList.remove('highlight');
  document.getElementById('searchResults').innerHTML = '';
}
